import { __extends } from "tslib";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Popover, Text } from '@marvelapp/ui';
import Close from './Close';
var LeaveComment = /** @class */ (function (_super) {
    __extends(LeaveComment, _super);
    function LeaveComment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onClose = function (e) {
            e.stopPropagation();
            _this.props.togglePopover();
        };
        return _this;
    }
    LeaveComment.prototype.componentDidMount = function () {
        this.props.onComponentDidMount();
    };
    LeaveComment.prototype.render = function () {
        var _a = this.props, isPopoverOpen = _a.isPopoverOpen, onLeaveCommentClick = _a.onLeaveCommentClick;
        return (React.createElement(Popover, { isActive: isPopoverOpen, showOn: "custom", width: 138 },
            React.createElement(Text, { color: "slate", fontFamily: 0, fontSize: 2, lineHeight: 1.3, onClick: onLeaveCommentClick, padding: "12px 10px", textAlign: "center" }, "Leave a comment on this design!"),
            React.createElement(Close, { kind: "light", onClick: this._onClose })));
    };
    LeaveComment.propTypes = {
        isPopoverOpen: PropTypes.bool.isRequired,
        togglePopover: PropTypes.func.isRequired,
        onComponentDidMount: PropTypes.func.isRequired,
        onLeaveCommentClick: PropTypes.func.isRequired,
    };
    return LeaveComment;
}(Component));
export default LeaveComment;
